import { render, staticRenderFns } from "./CompanyDrawerContactTabEmails.vue?vue&type=template&id=77b8e996&"
import script from "./CompanyDrawerContactTabEmails.vue?vue&type=script&lang=ts&"
export * from "./CompanyDrawerContactTabEmails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports